import {createReducer} from 'utils/redux';
import {SET_FOLLOWING_PICKS} from 'actions/followingPicks';
import {UNFOLLOW_STRATEGY} from 'actions/followingStrategies';

const initialState = [];

export default createReducer(initialState, {
  [SET_FOLLOWING_PICKS]: (state, {payload: picks = []}) => picks.filter(({resolved}) => !resolved),
  [UNFOLLOW_STRATEGY]: (state, {payload: strategyId}) => state.filter(pick => pick.strategyId !== strategyId),
});
